// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NucleusteqVoiceImages_images {
  width: 302px;
  height: 388px;
  margin: 0 auto;
  text-align: center;
}
@media (min-width: 2560px) {
  .NucleusteqVoiceImages_images {
    width: 420px;
    height: 540px;
    margin: 0 auto;
    text-align: center;
  }
}
@media screen and (min-width: 1280px) and (max-width: 1920px) {
  .NucleusteqVoiceImages_images {
    width: 258px;
    height: 318px;
    margin: 0 auto;
    text-align: center;
  }
}
@media (max-width: 990px) {
  .NucleusteqVoiceImages_images {
    width: 20vw;
  }
}
@media (max-width: 576px) {
  .NucleusteqVoiceImages_images {
    width: 263px;
    height: 343px;
    align-items: center;
    display: flex;
    margin: 0 auto;
  }
}
@media (max-width: 550px) {
  .NucleusteqVoiceImages .voiceDiv {
    height: 51vh !important;
  }
}
.NucleusteqVoiceImages_name {
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 17.372px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 26.059px */
  text-transform: uppercase;
  padding-top: 14.8px;
  text-align: center;
}
.NucleusteqVoiceImages_designation {
  color: var(--Nucleus-Orange, #f15d30);
  text-align: center;
  font-family: Roboto;
  font-size: 14.477px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 21.716px */
  padding-top: 2px;
  text-align: center;
}
.NucleusteqVoiceImages_thought {
  color: var(--White, #fff);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  padding-top: 5px;
  text-align: center;
}
@media (max-width: 576px) {
  .NucleusteqVoiceImages_thought {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    padding-top: 5px;
    align-items: center;
    display: flex;
    margin-left: 7vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/NucleusteqVoiceImages/nucleusteqVoiceImages.scss"],"names":[],"mappings":"AACE;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;AAAJ;AACI;EALF;IAMI,YAAA;IACA,aAAA;IACA,cAAA;IACA,kBAAA;EAEJ;AACF;AADI;EAXF;IAYI,YAAA;IACA,aAAA;IACA,cAAA;IACA,kBAAA;EAIJ;AACF;AAHI;EAjBF;IAkBI,WAAA;EAMJ;AACF;AALI;EApBF;IAqBI,YAAA;IACA,aAAA;IACA,mBAAA;IACA,aAAA;IACA,cAAA;EAQJ;AACF;AALI;EADF;IAEI,uBAAA;EAQJ;AACF;AANE;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAQJ;AANE;EACE,qCAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,gBAAA;EACA,kBAAA;AAQJ;AANE;EACE,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,gBAAA;EACA,kBAAA;AAQJ;AAPI;EATF;IAUI,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,gBAAA;IACA,mBAAA;IACA,aAAA;IACA,gBAAA;EAUJ;AACF","sourcesContent":[".NucleusteqVoiceImages {\n  &_images {\n    width: 302px;\n    height: 388px;\n    margin: 0 auto;\n    text-align: center;\n    @media (min-width: 2560px) {\n      width: 420px;\n      height: 540px;\n      margin: 0 auto;\n      text-align: center;\n    }\n    @media screen and (min-width: 1280px) and (max-width: 1920px) {\n      width: 258px;\n      height: 318px;\n      margin: 0 auto;\n      text-align: center;\n    }\n    @media (max-width:990px){\n      width:20vw;\n    }\n    @media (max-width: 576px) {\n      width: 263px;\n      height: 343px;\n      align-items: center;\n      display: flex;\n      margin: 0 auto;\n    }\n  }\n  .voiceDiv{\n    @media (max-width:550px){\n      height:51vh !important ;\n    }\n  }\n  &_name {\n    color: #fff;\n    text-align: center;\n    font-family: Roboto;\n    font-size: 17.372px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%; /* 26.059px */\n    text-transform: uppercase;\n    padding-top: 14.8px;\n    text-align: center;\n  }\n  &_designation {\n    color: var(--Nucleus-Orange, #f15d30);\n    text-align: center;\n    font-family: Roboto;\n    font-size: 14.477px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%; /* 21.716px */\n    padding-top: 2px;\n    text-align: center;\n  }\n  &_thought {\n    color: var(--White, #fff);\n    font-family: Roboto;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 24px */\n    padding-top: 5px;\n    text-align: center;\n    @media (max-width: 576px) {\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%;\n      padding-top: 5px;\n      align-items: center;\n      display: flex;\n      margin-left: 7vw;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
